import { useEffect, useState } from 'react';

/**
 * Index range (inclusive) into a daily series for chart/matrix views.
 * Resets to the full span when the report changes (`resetKey`) or when the series length changes.
 *
 * Returns two range values:
 * - `dateRange` — updates on every slider drag tick (keeps the slider thumb responsive).
 * - `committedDateRange` — updates only when the user releases the slider (`onRangeCommit`).
 *   Use this for expensive downstream work (chart data, matrix rendering).
 */
export function useParityReportDateRange(seriesLength: number, resetKey: unknown) {
  const [dateRange, setDateRange] = useState<Array<number>>(() => [0, Math.max(0, seriesLength - 1)]);

  const [committedDateRange, setCommittedDateRange] = useState<Array<number>>(() => [0, Math.max(0, seriesLength - 1)]);

  useEffect(() => {
    const full = [0, Math.max(0, seriesLength - 1)];
    setDateRange(full);
    setCommittedDateRange(full);
  }, [resetKey, seriesLength]);

  return { dateRange, setDateRange, committedDateRange, setCommittedDateRange };
}
